import React from 'react';
import siteConfig from '../../config/siteConfig';

export const SoftwareApplicationSchema: React.FC<{}> = () => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'Perxify Commerce Cloud',
    applicationCategory: 'BusinessApplication',
    applicationSubCategory: 'E-commerce Platform',
    operatingSystem: 'Web Browser',
    description: 'AI-powered Commerce Cloud platform for building e-commerce stores, marketplaces, loyalty programs, and analytics solutions',
    url: siteConfig.baseUrl,
    downloadUrl: `${siteConfig.baseUrl}/contact/schedule-demo`,
    softwareVersion: '2024.1',
    datePublished: '2024-01-01',
    dateModified: new Date().toISOString().split('T')[0],
    author: {
      '@type': 'Organization',
      name: siteConfig.organization.name,
      url: siteConfig.baseUrl,
    },
    publisher: {
      '@type': 'Organization',
      name: siteConfig.organization.name,
      url: siteConfig.baseUrl,
      logo: {
        '@type': 'ImageObject',
        url: `${siteConfig.assetUrl}/images/logo.png`,
      },
    },
    offers: [
      {
        '@type': 'Offer',
        name: 'Pro Suite',
        description: 'E-commerce store with loyalty program and basic analytics',
        priceCurrency: 'EUR',
        priceSpecification: {
          '@type': 'UnitPriceSpecification',
          price: '100',
          priceCurrency: 'EUR',
          billingPeriod: 'P1M',
        },
        additionalProperty: {
          '@type': 'PropertyValue',
          name: 'Transaction Fee',
          value: '2.5%',
        },
      },
      {
        '@type': 'Offer',
        name: 'Growth',
        description: 'Up to 10 stores with advanced analytics and API access',
        priceCurrency: 'EUR',
        priceSpecification: {
          '@type': 'UnitPriceSpecification',
          price: '1000',
          priceCurrency: 'EUR',
          billingPeriod: 'P1M',
        },
        additionalProperty: {
          '@type': 'PropertyValue',
          name: 'Transaction Fee',
          value: '1%',
        },
      },
      {
        '@type': 'Offer',
        name: 'Advanced',
        description: 'Unlimited stores with custom blockchain and full white label',
        priceCurrency: 'EUR',
        priceSpecification: {
          '@type': 'UnitPriceSpecification',
          price: '3000',
          priceCurrency: 'EUR',
          billingPeriod: 'P1M',
        },
        additionalProperty: {
          '@type': 'PropertyValue',
          name: 'Transaction Fee',
          value: '2%',
        },
      },
      {
        '@type': 'Offer',
        name: 'Marketplace',
        description: 'Full marketplace functionality with unlimited admins',
        priceCurrency: 'EUR',
        priceSpecification: {
          '@type': 'UnitPriceSpecification',
          price: '5000',
          priceCurrency: 'EUR',
          billingPeriod: 'P1M',
        },
        additionalProperty: {
          '@type': 'PropertyValue',
          name: 'Transaction Fee',
          value: '2.5%',
        },
      },
      {
        '@type': 'Offer',
        name: 'Enterprise',
        description: 'Custom solutions for large organizations',
        priceCurrency: 'EUR',
        price: 'Custom pricing',
      },
    ],
    featureList: [
      'AI-Powered Commerce',
      'Multi-Vendor Marketplace',
      'Loyalty Programs',
      'Advanced Analytics',
      'Blockchain Integration',
      'API-First Architecture',
      'White Label Solutions',
    ],
    screenshot: `${siteConfig.assetUrl}/images/platform-screenshot.jpg`,
    softwareRequirements: 'Modern web browser with JavaScript enabled',
    installUrl: `${siteConfig.baseUrl}/contact/schedule-demo`,
    softwareHelp: `${siteConfig.baseUrl}/faq`,
    releaseNotes: `${siteConfig.baseUrl}/blog`,
    maintainer: {
      '@type': 'Organization',
      name: siteConfig.organization.name,
      email: siteConfig.organization.contact.email,
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};